/* eslint-disable no-restricted-imports */
import { sfLike as originalSfLike } from 'spring-filter-query-builder';
import { Like } from 'spring-filter-query-builder/dist/types/comparators';

// Same signature, but last parameter is required
// This is to avoid confusion with case sensitivity
export const sfLike: (selector: string, value: string, caseInsensitive: boolean) => Like = originalSfLike;
